// extracted by mini-css-extract-plugin
export default {"container":"course_container__rlNXw"};